/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdPhoto200,
  GetApiV1PersonIdPhoto401,
  GetApiV1PersonIdPhoto404,
  GetApiV1PersonIdPhoto500,
  GetApiV1PersonIdPhotoPathParams,
  GetApiV1PersonIdPhotoQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdPhoto.ts";

export const getApiV1PersonIdPhotoPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdPhotoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdPhoto200Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdPhoto200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdPhoto401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdPhoto401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdPhoto404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdPhoto404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdPhoto500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdPhoto500>;

export const getApiV1PersonIdPhotoQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdPhoto200Schema,
) as unknown as ToZod<GetApiV1PersonIdPhotoQueryResponse>;
